export default __webpack_public_path__ + "static/media/ingredients.f424eca4.svg";